// extracted by mini-css-extract-plugin
export var cardSelected = "_gv-2";
export var image = "_gv-1";
export var table = "_gv-0";